module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp1_3009.4224acb7.png";